import Slick from './plugins/slick.js';
import matchHeight from './plugins/jquery.matchHeight.js';
(function($) {

// Use this variable to set up the common and page specific functions. If you
// rename this variable, you will also need to rename the namespace below.
var Base = {
  // All pages
  common: {
    init: function() {
      /////
      // JavaScript to be fired on all pages
      /////

      // Impact Section
      $('.images-wrapper').on('mouseenter', function(){
        $(this).addClass('hover');
        $(this).children('.image:first-child').addClass('hover');
      });
      $('.images-wrapper').on('mouseleave', function(){
        $('.toggle').removeClass('hover');
        $(this).removeClass('hover');
        $(this).children('.image').removeClass('hover');
      });
      $('.image').on('mouseenter', function(){
        $(this).addClass('hover');
        $(this).siblings('.image').removeClass('hover');
        $('.toggle').removeClass('hover');
        $('.toggle[data-id="' + $(this).attr('data-id') + '"]').addClass('hover');
      });
      $('.toggle').on('mouseenter', function(){
        $('.image').removeClass('hover');
        $('.image[data-id="' + $(this).attr('data-id') + '"]').addClass('hover');
        $('.image[data-id="' + $(this).attr('data-id') + '"]').parents('.images-wrapper').addClass('hover');
      });
      $('.toggle').on('mouseleave', function(){
        $('.image').removeClass('hover');
        $('.images-wrapper').removeClass('hover');
      });
    
      // Match Height Helper Class
      $('.match-height-row').matchHeight({
        byRow: true,
        property: 'min-height'
      });
      $('.match-height-secondary').matchHeight({
        byRow: true,
        property: 'min-height'
      });
      $('.match-height').matchHeight({
        byRow: false,
        property: 'min-height'
      });

      // Hero Gradients
      function shuffle(array) {
        var m = array.length, t, i;
        while (m) {
          i = Math.floor(Math.random() * m--);
          t = array[m];
          array[m] = array[i];
          array[i] = t;
        }
        return array;
      }
      setInterval(function(){
        $('.hero .gradient').removeClass('active');
        var gradient = shuffle($('.hero .gradient')).slice(0, 1);
        gradient.addClass('active');
      }, 2500);
      // Hero Slider
      $('.hero-slider').on('click', '.slick-slide:not(.current) .slide', function(e){
        if ($(e.target).parents('.slick-slide').hasClass('next') || $(e.target).parents('.slick-slide').hasClass('nextnext') || $(e.target).parents('.slick-slide').hasClass('nextnextnext')) {
          $('.hero-slider').slick('slickNext');
        } else {
          $('.hero-slider').slick('slickPrev');
        }
      });
      $('.hero-slider').on('init', function(event, slick, direction){
        for (var i = 0; i < slick.$slides.length; i++) {
            var $slide = $(slick.$slides[i]);
            if ($slide.hasClass('slick-current')) {
              $slide.addClass('current');
              $slide.next().addClass('next');
              $slide.next().next().addClass('nextnext');
              $slide.next().next().next().addClass('nextnextnext');
              $slide.next().next().next().next().addClass('prevprevprev');
              $slide.next().next().next().next().next().addClass('prevprev');
              $slide.next().next().next().next().next().next().addClass('prev');
              break;
            }
          }
      })
      .on('beforeChange', function(event, slick, currentSlide, nextSlide){
        var prev = false;
        if (currentSlide > nextSlide || currentSlide == 0) {
          prev = true;
          if (currentSlide == 6 && nextSlide == 0) {
            prev = false;
          }
          if (currentSlide == 0 && nextSlide == 1) {
            prev = false;
          }
        }
        for (var i = 0; i < slick.$slides.length; i++) {
          var $slide = $(slick.$slides[i]);
          if (prev) {
            if ($slide.hasClass('prev')) {
              $slide.removeClass('prev').addClass('current-new');
            }
            if ($slide.hasClass('prevprev')) {
              $slide.removeClass('prevprev').addClass('prev');
            }
            if ($slide.hasClass('prevprevprev')) {
              $slide.removeClass('prevprevprev').addClass('prevprev');
            }
            if ($slide.hasClass('nextnextnext')) {
              $slide.removeClass('nextnextnext').addClass('prevprevprev');
            }
            if ($slide.hasClass('nextnext')) {
              $slide.removeClass('nextnext').addClass('nextnextnext');
            }
            if ($slide.hasClass('next')) {
              $slide.removeClass('next').addClass('nextnext');
            }
            if ($slide.hasClass('current')) {
              $slide.addClass('next').removeClass('current');
            }
            if ($slide.hasClass('current-new')) {
              $slide.addClass('current').removeClass('current-new');
            }
          } else {
            if ($slide.hasClass('next')) {
              $slide.removeClass('next').addClass('current-new');
            }
            if ($slide.hasClass('nextnext')) {
              $slide.removeClass('nextnext').addClass('next');
            }
            if ($slide.hasClass('nextnextnext')) {
              $slide.removeClass('nextnextnext').addClass('nextnext');
            }
            if ($slide.hasClass('prevprevprev')) {
              $slide.removeClass('prevprevprev').addClass('nextnextnext');
            }
            if ($slide.hasClass('prevprev')) {
              $slide.removeClass('prevprev').addClass('prevprevprev');
            }
            if ($slide.hasClass('prev')) {
              $slide.removeClass('prev').addClass('prevprev');
            }
            if ($slide.hasClass('current')) {
              $slide.addClass('prev').removeClass('current');
            }
            if ($slide.hasClass('current-new')) {
              $slide.addClass('current').removeClass('current-new');
            }
          }
        }
      })
      .slick({
        fade: true,
        slidesToShow: 1,
        dots: false
      });
      $('#nav-toggle').click(function(){
        $('body').toggleClass('nav-open');
        $('#popup-menu').toggleClass('visible');
        $(this).toggleClass('active');
      });
      $('#popup-menu').click(function(){
        $('body').removeClass('nav-open');
        $('#popup-menu').removeClass('visible');
        $('#nav-toggle').removeClass('active');
      });
      $('#sticky-arrow').click(function(){
        var $nextsection;
        $('section').each(function(){
          if ($(this).offset().top > $(window).scrollTop()) {
            $nextsection = $(this);
            return false;
          }
        });
        $([document.documentElement, document.body]).animate({
            scrollTop: $nextsection.offset().top + 1
        }, 1000);
      });
      $('#scroll-top').click(function(e){
        e.preventDefault();
        $([document.documentElement, document.body]).animate({
            scrollTop: 0
        }, 1000);
      });

      this.scroll_actions;
      $(document).ready(this.scroll_actions);
      $(window).scroll(this.scroll_actions);
      $(window).bind('load', this.scroll_actions);
    },
    scroll_actions: function() {
      $('.svg-wrapper').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100 && $this.offset().top + $this.height() > $(window).scrollTop() + 100) {
          $this.addClass('loaded');
        } else {
          $this.removeClass('loaded');
        }
      });
      $('.animate').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          $this.addClass('visible');
        }
      });
      $('.animate-1').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          $this.addClass('visible');
        }
      });
      $('.animate-1b').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 100);
        }
      });
      $('.animate-2').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 200);
        }
      });
      $('.animate-2b').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 300);
        }
      });
      $('.animate-3').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 400);
        }
      });
      $('.animate-3b').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 500);
        }
      });
      $('.animate-4').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 600);
        }
      });
      $('.animate-4b').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 700);
        }
      });
      $('.animate-5').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 800);
        }
      });
      $('.animate-5b').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 900);
        }
      });
      $('.animate-6').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 1000);
        }
      });
      $('.animate-6b').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 1100);
        }
      });
      $('.animate-7').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 1200);
        }
      });
      $('.animate-7b').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 1300);
        }
      });
      $('.animate-8').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 1400);
        }
      });
      $('.animate-8b').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 1500);
        }
      });
      $('.animate-9').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 1600);
        }
      });
      $('.animate-9b').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 1700);
        }
      });
      $('.animate-10').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 1800);
        }
      });
      $('.animate-10b').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 1900);
        }
      });
      $('.animate-11').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 2000);
        }
      });
      $('.animate-11b').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 2100);
        }
      });
      $('.animate-12').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 2200);
        }
      });
      $('.animate-12b').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 2300);
        }
      });
      $('.animate-13').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 2400);
        }
      });
      $('.animate-13b').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 2500);
        }
      });
      $('.animate-14').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 2600);
        }
      });
      $('.animate-14b').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 2700);
        }
      });
      $('.animate-15').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 2800);
        }
      });
      $('.animate-15b').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 2900);
        }
      });
      $('.animate-16').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 3000);
        }
      });
      $('.animate-16b').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 3100);
        }
      });
      $('.animate-17').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 3200);
        }
      });
      $('.animate-17b').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 3300);
        }
      });
      $('.animate-18').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 3400);
        }
      });
      $('.animate-18b').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 3500);
        }
      });
      $('.animate-19').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 3600);
        }
      });
      $('.animate-19b').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 3700);
        }
      });
      $('.animate-20').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 3800);
        }
      });
      $('.animate-20b').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 3900);
        }
      });
      $('.animate-21').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 4000);
        }
      });
    }
  }
};

// The routing fires all common scripts, followed by the page specific scripts.
// Add additional events for more control over timing e.g. a finalize event
var UTIL = {
  fire: function(func, funcname, args) {
    var namespace = Base;
    funcname = (funcname === undefined) ? 'init' : funcname;
    if (func !== '' && namespace[func] && typeof namespace[func][funcname] === 'function') {
      namespace[func][funcname](args);
    }
  },
  loadEvents: function() {
    UTIL.fire('common');

    $.each(document.body.className.replace(/-/g, '_').split(/\s+/),function(i,classnm) {
      UTIL.fire(classnm);
    });
  }
};

$(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.